import React from "react";

function Step5() {
  return (
    <div className="mm-finish">
      <img
        src={process.env.PUBLIC_URL + "/img/finish.svg"}
        alt=""
        className="mm-finish__logo"
      />
      <div className="mm-finish__text1">Ошибка</div>
      <div className="mm-finish__text2">
        Вы уже подавали заявку ранее, если хотите внести изменения в
        отправленную заявку, напишите на почту:{" "}
        <a href="mailto:BushuevSS@mos.ru">BushuevSS@mos.ru</a>.
      </div>
    </div>
  );
}

export default Step5;
